var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-text-field',{attrs:{"label":_vm.theOption.title},on:{"change":_vm.textChange},model:{value:(_vm.theText),callback:function ($$v) {_vm.theText=$$v},expression:"theText"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }